module.exports = __webpack_public_path__ + "img/chat-incoming.817dd0db.svg";